import { APICore } from '../helpers/api/apiCore';
import { findObject } from '../utils/AllFunction';
import { apiReturnCallBack } from './ApiConfig';
import apiContainer from './apiContainer';
const api = new APICore();

const Outstanding = apiContainer.Outstanding
//GET--->
// Corrected getOutstanding function
export async function getOutstandingApi(request) {
    let findObj = findObject(request);
    try {
        return api.get(`${Outstanding}`, findObj);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
